import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 808;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = 'cb7d347a-c002-4131-8529-e2b9aad34adb-808';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
